module.exports = __webpack_public_path__ + "img/Slice 268@2x(1).14514d5f.png";